export const NatureOfBusiness = [
  'Accounting_Auditing',
  'Administrative_and_Support_Services',
  'Advertising_Marketing_Public_Relations',
  'Agriculture_Forestry_and_Fishing',
  'Architectural_Services',
  'Arts_Entertainment_and_Media',
  'Banking',
  'Biotechnology_and_Pharmaceutical',
  'Community_Social_Services_and_Nonprofit',
  'Computers_Information_Technology',
  'Construction_Mining_and_Trades',
  'Consulting_Services',
  'Customer_Service_and_Call_Center',
  'Education_Training_and_Library',
  'Employment_Placement_Agencies',
  'Engineering',
  'Finance_Economics',
  'Financial_Services',
  'Government_and_Policy',
  'Healthcare_Other',
  'Healthcare_Practitioner_and_Technician',
  'Hospitality_Tourism',
  'Human_Resources',
  'Installation_Maintenance_and_Repair',
  'Insurance',
  'Internet_E_Commerce',
  'Law_Enforcement_and_Security',
  'Legal',
  'Manufacturing_and_Production',
  'Military',
  'Other',
  'Personal_Care_and_Service',
  'Real_Estate',
  'Restaurant_and_Food_Service',
  'Retail_Wholesale',
  'Sales',
  'Science',
  'Sports_and_Recreation',
  'Telecommunications',
  'Transportation_and_Warehousing',

  // Prepop
  'Accounting/Auditing',
  'Administrative and Support Services',
  'Advertising/Marketing/Public Relations',
  'Agriculture, Forestry, and Fishing',
  'Architectural Services',
  'Arts, Entertainment, and Media',
  'Banking',
  'Biotechnology and Pharmaceutical',
  'Community, Social Services, and Nonprofit',
  'Computers, Information Technology',
  'Construction, Mining and Trades',
  'Consulting Services',
  'Customer Service and Call Center',
  'Education, Training, and Library',
  'Employment Placement Agencies',
  'Engineering',
  'Finance/Economics',
  'Financial Services',
  'Government and Policy',
  'Healthcare, Other',
  'Healthcare, Practitioner and Technician',
  'Hospitality/Tourism',
  'Human Resources',
  'Installation, Maintenance, and Repair',
  'Insurance',
  'Internet/E-Commerce',
  'Law Enforcement, and Security',
  'Legal',
  'Manufacturing and Production',
  'Military',
  'Other',
  'Personal Care and Service',
  'Real Estate',
  'Restaurant and Food Service',
  'Retail/Wholesale',
  'Sales',
  'Science',
  'Sports and Recreation',
  'Telecommunications',
  'Transportation and Warehousing'
];
